import { GET_CALL_HISTORY } from "./callTypes";

export default {
  [GET_CALL_HISTORY](state, data) {
    state.callHistory = data;
  },
}
